import React from 'react';
import styled from 'astroturf/react';
import { Banner as BannerBase } from 'js/design_system/Banner';
import { TextButton } from 'js/design_system/TextButton';
import { InfoIcon } from 'js/social/shared/Icons';

const ErrorStateContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 8px;
  gap: 16px;
`;

const BannerText = styled.div`
  gap: 0px;
`;

const ReloadButton = styled(TextButton)`
  font-size: 16px;
  padding: 0;
  font-weight: 400;
  display: inline;
`;

const Banner = styled(BannerBase)`
  width: 100%;
  color: $ds-black;
`;

const ErrorStateFeed: React.FC = () => {
  return (
    <ErrorStateContainer>
      <Banner icon={<InfoIcon />}>
        <BannerText>
          Something went wrong. Please{' '}
          <ReloadButton inline onClick={() => window.location.reload()}>
            reload
          </ReloadButton>{' '}
          the page.
        </BannerText>
      </Banner>
    </ErrorStateContainer>
  );
};

export default ErrorStateFeed;
